export default __webpack_public_path__ + "static/media/decoder_ring_screen.2facc00a.png";